<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

onMounted(() => {
  new Highcharts.chart("appliedBar", {
    chart: {
      type: "column",
      height: 275, backgroundColor: "transparent",
    },
    title: {
      text: "",
    }, legend: { enabled: false },
    xAxis: {
      categories: ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    },
    yAxis: {
      min: 0,
      title: {
        text: "% of Applcants by Gender",
      }, labels: {
        format: "{value}%",
      },
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}"><b>{series.name}</b></span>: {point.y}%<br/>',
      shared: true,
    },
    plotOptions: {
      column: {
        stacking: "percent",
      },
    },
    series: [{
      name: "Men",
      data: [49.1, 49.2, 48.6, 47.8, 47.3, 46.7, 46.0, 47.2, 47.2, 46.7, 45.9, 46.4, 47.5, 48.3, 48.8, 49.6],
    }, {
      name: "Women",
      data: [50.2, 50.2, 49.7, 49.2, 49.0, 48.6, 48.4, 49.1, 49.3, 48.3, 47.5, 48.1, 49.1, 49.6, 50.0, 50.8],
    }, {
      name: "% College Grads Who Are Women",
      type: "spline", color: "#FF0000", marker: { lineWidth: 2 },
      data: [57.2, 57.3, 57.4, 57.5, 57.5, 57.4, 57.5, 57.4, 57.3, 57.2, 57.2, 57.2, 57.3, 57.2, 57.1, 57.1],
    }],
  })

  new Highcharts.chart("admittedBar", {
    chart: {
      type: "column",
      height: 275, backgroundColor: "transparent",
    },
    title: {
      text: "",
    }, legend: { enabled: false },
    xAxis: {
      categories: ["2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015"],
    },
    yAxis: {
      min: 0,
      title: {
        text: "% Admitted by Gender",
      }, labels: {
        format: "{value}%",
      },
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}"><b>{series.name}</b></span>: {point.y}%<br/>',
      shared: true,
    },
    plotOptions: {

    },
    series: [{
      name: "Men",
      data: [69.8, 69.1, 64.0, 59.4, 57.9, 61.4, 66.5, 68.9, 69.8, 69.6, 70.9, 73.5, 76.9, 78.9, 79.9, 79.5],
    }, {
      name: "Women",
      data: [66.7, 66.3, 61.3, 56.1, 54.2, 56.9, 60.6, 63.9, 64.1, 65.5, 66.5, 68.7, 72.1, 74.9, 76.1, 75.8],
    }],
  })

  new Highcharts.chart("enrolledBar", {
    chart: {
      type: "column",
      height: 325, backgroundColor: "transparent",
    }, legend: { enabled: true },
    title: {
      text: "",
    },
    xAxis: {
      categories: ["1993", "1994", "1995", "1996", "1997", "1998", "1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016"],
    },
    yAxis: {
      min: 0,
      title: {
        text: "% of JD Enrollment by Gender",
      }, labels: {
        format: "{value}%",
      },
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}"><b>{series.name}</b></span>: {point.y}%<br/>',
      shared: true,
    },
    plotOptions: {
      column: {
        stacking: "percent",
      },
    },
    series: [{
      name: "Men",
      data: [56.9, 56.7, 56, 55.6, 54.8, 53.9, 52.6, 51.6, 51, 51, 51.3, 52, 52.5, 53.1, 53.3, 53.1, 52.8, 53.2, 53.3, 53, 52.1, 51.2, 50.6, 49.7],
    }, {
      name: "Women",
      data: [43.1, 43.3, 44, 44.4, 45.2, 46.1, 47.4, 48.4, 49, 49, 48.7, 48, 47.5, 46.9, 46.7, 46.9, 47.2, 46.8, 46.7, 47, 47.9, 48.8, 49.4, 50.3],
    }],
  })
})
</script>
